/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import styled from "styled-components";

import {
  StyledHelperText,
  StyledLabel,
  StyledRequired,
  StyledSpacer14,
} from "../superAdmin/catalog/lib/styles";
import { theme } from "../theme/theme";

type SelectOptions = {
  id: string;
  name: string;
};

type SelectInputFieldPropTypes = {
  disabled?: boolean;
  handleChange: (event) => void;
  helperText?: string;
  id: string;
  isRequired?: boolean;
  label: string;
  options: SelectOptions[];
  value?: string;
};

export const StyledSelect = styled(Select)`
  width: 100%;
  height: 46px;
  border-radius: ${theme.radius.s};
  border: 1px solid ${theme.color.gray300};

  & .MuiSelect-select:focus {
    background-color: transparent;
  }

  & .MuiSelect-select {
    padding-left: 14px;
    font-family: ${theme.fontFamily};
    color: ${theme.color.gray800};
    font-size: ${theme.fontSize.m};
    min-height: 0;
  }

  & .MuiSelect-icon {
    top: calc(50% - 10px);
    right: 8px;
    color: ${theme.color.gray800};
    font-size: ${theme.fontSize.xxl};
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &&& {
    color: ${theme.color.gray800};
    font-family: ${theme.fontFamily};
    font-size: ${theme.fontSize.m};

    li&:hover {
      background-color: ${theme.color.gray100};
    }
  }
`;

const SelectInputField = ({
  disabled,
  handleChange,
  helperText,
  id,
  isRequired,
  label,
  options,
  value,
}: SelectInputFieldPropTypes): React.ReactElement => {
  return (
    <>
      <StyledLabel htmlFor={id}>
        {label}
        {isRequired && <StyledRequired>*</StyledRequired>}
      </StyledLabel>
      <StyledSelect
        disableUnderline
        disabled={disabled}
        id={id}
        inputProps={{ "data-selectedval": value, "data-testid": id }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        onChange={handleChange}
        value={value}
      >
        {options.map((option) => {
          return (
            <StyledMenuItem key={option.id} value={option.id}>
              {option.name}
            </StyledMenuItem>
          );
        })}
      </StyledSelect>
      {helperText && (
        <>
          <StyledSpacer14 />
          <StyledHelperText>{helperText}</StyledHelperText>
        </>
      )}
    </>
  );
};

SelectInputField.defaultProps = {
  value: "",
};

export default SelectInputField;
